import { TypeGenerator, isDigit, isInteger } from '../utils/type';
import { IArgumentType } from '../functions/utils';
import { hasNotDigitArgs, hasNumberArgs } from '../functions/utils';
import { InferenceError } from '../errors';
import { IFunctionToken } from '../typings/token';


export function MAX(args: IArgumentType[], token: IFunctionToken) {
  const functionName = token.formatName;

  const firstArgType = args[0];
  if (isDigit(firstArgType, true)) {
    if (args.length > 1) {
      throw new InferenceError('function-argument-error', `${functionName} 函数的第一个参数如果为数组，则只接受一个参数`, token.position);
    }

    return isInteger(firstArgType, true) ?
      TypeGenerator.Integer() :
      TypeGenerator.Number();
  }

  if (hasNotDigitArgs(args)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的参数不能为非数字类型`, token.position);
  }

  return hasNumberArgs(args) ? TypeGenerator.Number() : TypeGenerator.Integer();
}
